function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#2FF583"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 294,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 154,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 434,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 42,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 322,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 182,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 462,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 70,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 350,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 210,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 490,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 98,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 378,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 238,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 518,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 126,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 406,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 266,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 546,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 308,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 168,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 448,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 336,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 196,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 476,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 84,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 364,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 224,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 504,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 112,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 392,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 532,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 140,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 420,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 280,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 560,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 574,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 588,
  width: 7.8421,
  height: 33,
  rx: 3.92105,
  fill: "#D9D9D9"
});

var SvgAnimatedBar = function SvgAnimatedBar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 596,
    height: 33,
    viewBox: "0 0 596 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnimatedBar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/animated-bar.6e2b4719.svg";
export { ForwardRef as ReactComponent };